import type { OrderListingStatus } from '@/libs/interfaces'

import { MOCK_ORG_ID, MOCK_STORE_ID_1 } from './seed'

/** Shared kanban-style order listing status fixture data. */
export const mockOrderListingStatuses: OrderListingStatus[] = [
  {
    orderListingStatusID: 'order-listing-status-1',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    kanbanPosition: '1',
    name: 'Received',
    createdAt: '2025-01-01T08:00:00Z',
    updatedAt: '2025-01-01T08:00:00Z',
  },
  {
    orderListingStatusID: 'order-listing-status-2',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    kanbanPosition: '2',
    name: 'In Progress',
    createdAt: '2025-01-01T08:00:00Z',
    updatedAt: '2025-01-01T08:00:00Z',
  },
  {
    orderListingStatusID: 'order-listing-status-3',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    kanbanPosition: '3',
    name: 'Quality Check',
    createdAt: '2025-01-01T08:00:00Z',
    updatedAt: '2025-01-01T08:00:00Z',
  },
  {
    orderListingStatusID: 'order-listing-status-4',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    kanbanPosition: '4',
    name: 'Ready for Pickup',
    createdAt: '2025-01-01T08:00:00Z',
    updatedAt: '2025-01-01T08:00:00Z',
  },
  {
    orderListingStatusID: 'order-listing-status-5',
    orgID: MOCK_ORG_ID,
    storeID: MOCK_STORE_ID_1,
    kanbanPosition: '5',
    name: 'Completed',
    createdAt: '2025-01-01T08:00:00Z',
    updatedAt: '2025-01-01T08:00:00Z',
  },
]
